/**
 * Приложение результата оплаты.
 *
 * Определяет тип страницы (success/fail) по URL pathname:
 *   /orders/payment/success/?orderId=... → PurchaseSuccess (с деталями заказа)
 *   /orders/payment/fail/?orderId=...    → PaymentFail
 *
 * orderId в URL — это payment.uid (уникальный случайный идентификатор платежа).
 * Frontend получает заказ через API: GET /orders/api/payments/{payment_uid}/order/
 */
import { PurchaseSuccess } from './components/PurchaseSuccess';
import { PaymentFail } from './components/PaymentFail';

/**
 * Получить payment uid из query-параметров URL.
 * 
 * Параметр называется "orderId" для совместимости с IntellectMoney,
 * но на самом деле это payment.uid (уникальный случайный идентификатор).
 */
function getPaymentId() {
  const params = new URLSearchParams(window.location.search);
  return params.get('orderId') || '';
}

/**
 * Определить тип страницы по pathname.
 * Возвращает 'success', 'fail' или 'unknown'.
 */
function getPageType() {
  const path = window.location.pathname;

  if (path.includes('/success')) return 'success';
  if (path.includes('/fail')) return 'fail';

  return 'unknown';
}

function App() {
  const paymentId = getPaymentId();
  const pageType = getPageType();

  if (pageType === 'success') {
    return <PurchaseSuccess paymentId={paymentId} />;
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center py-8 px-4">
      {pageType === 'fail' && (
        <PaymentFail paymentId={paymentId} />
      )}

      {pageType === 'unknown' && (
        <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-8 max-w-lg mx-auto text-center">
          <div className="text-6xl mb-4">🤔</div>
          <h1 className="text-xl font-bold mb-2 text-gray-900 dark:text-white">
            Страница не найдена
          </h1>
          <p className="text-gray-500 dark:text-gray-400 mb-6">
            Эта страница предназначена для отображения результата оплаты.
          </p>
          <a
            href="/"
            className="inline-block py-3 px-6 bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-semibold rounded-xl"
          >
            На главную
          </a>
        </div>
      )}
    </div>
  );
}

export default App;
